import CommonAPIService from './CommonHandler';

export class AIAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }
  make_ai_call(parameters, router) {
    const url = '/api/ai';
    return this.CommonAPIService.postCall(url, parameters, router);
  }
}

export default AIAPIService;
